module.exports = __webpack_public_path__ + "static/media/disabledTodayIcon.88062f15.svg";